import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './OtherSensors.css';
import config from '../config';

const SensorValue = ({ label, value, unit }) => (
  <div className="other-sensor-reading">
    <span className="reading-label">{label}:</span>
    <span className="reading-value">{value} {unit}</span>
  </div>
);

const ExternalSensorCard = ({ sensor, catalogue }) => {
  const typeInfo = catalogue.find(t => t.typeId === sensor.typeId);
  const sensorName = sensor.name || typeInfo?.name || `Sensor ${sensor.sensorId}`;

  return (
    <div className="external-sensor-card">
      <div className="external-sensor-header">
        <div className="external-sensor-title">{sensorName}</div>
        <div className="external-sensor-id">#{sensor.sensorId}</div>
      </div>
      <div className="external-sensor-body">
        {sensor.values.map((val, idx) => {
          const format = typeInfo?.valueFormats[idx];
          return (
            <SensorValue
              key={idx}
              label={format?.label || `Value ${idx}`}
              value={typeof val === 'number' ? val.toFixed(2) : val}
              unit={format?.unit || ''}
            />
          );
        })}
      </div>
    </div>
  );
};

const OtherSensors = () => {
  const navigate = useNavigate();
  const [devices, setDevices] = useState([]);
  const [catalogue, setCatalogue] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch catalogue and device summary in parallel
        const [catRes, sumRes] = await Promise.all([
          fetch(`${config.API_BASE_URL}/sensor-types`, {
            headers: { }
          }),
          fetch(`${config.API_BASE_URL}/devices/summary`, {
            headers: { }
          })
        ]);

        const catData = await catRes.json();
        const sumData = await sumRes.json();

        setCatalogue(catData);

        // Filter for devices that actually have external sensors
        setDevices(sumData.filter(d => d.latest?.sensors && d.latest.sensors.length > 0));
      } catch (error) {
        console.error('Error fetching sensor data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="other-sensors-safe-area">
      <div className="other-sensors-container">
        <div className="other-sensors-content">
          {/* Header */}
          <div className="other-sensors-header-row">
            <button className="back-button" onClick={() => navigate('/')}>
              <span className="back-icon">‹</span>
            </button>
            <div className="header-title-group">
              <div className="header-title-main">OTHER SENSORS</div>
              <div className="header-title-sub">EXTERNAL NETWORK</div>
            </div>
          </div>

          {loading ? (
            <div className="loading-state">Loading external network data...</div>
          ) : devices.length === 0 ? (
            <div className="empty-state">No external sensors detected in the network.</div>
          ) : (
            devices.map(device => (
              <div key={device.device_id} className="device-sensor-section">
                <div className="device-section-header">
                  <div className="device-section-name">{device.device_id.replace(/^MM-/, '')}</div>
                  <div className="device-section-line" />
                </div>
                <div className="external-sensor-grid">
                  {device.latest.sensors.map((sensor, idx) => (
                    <ExternalSensorCard
                      key={`${device.device_id}-${idx}`}
                      sensor={sensor}
                      catalogue={catalogue}
                    />
                  ))}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default OtherSensors;
